import DesktopTopBar from "./reusable/topBars/desktop/DesktopTopBar.jsx";
import MobileTopBar from "./reusable/topBars/mobile/MobileTopBar.jsx";
import { useMediaQuery } from "react-responsive";
import "./styles/projects.css";
import Project from "./reusable/Project";
import cuentaLogo from "../components/pictures/logoCuenta.png";
import mepLogo from "../components/pictures/logomark.png";
import tfLogo from "../components/pictures/tfLogo.png";

function Projects() {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const PROJECT_LIST = [
    {
      name: "Cuenta",
      description:
        "A web app to track your spendings, plan your budget, and work towards your financial goals.",
      logo: cuentaLogo,
      githubLinks: {
        diario: "https://github.com/michellebello/diario",
        contador: "https://github.com/michellebello/contador",
      },
    },
    {
      name: "Mise En Plate",
      description:
        "A recipe website, where users can upload, view, and review recipes.",
      logo: mepLogo,
      githubLinks: {
        "mep-frontend": "https://github.com/neon-super-nova/mep-frontend",
        "mep-backend": "https://github.com/neon-super-nova/mep-backend",
      },
    },
    {
      name: "Tooti Frooti",
      description:
        "A room-based game where users players race to fill letter-based answers.",
      logo: tfLogo,
      githubLinks: {
        "tooti frooti": "https://github.com/barahi/tootie-frootie",
        "gmp-backend": "https://github.com/barahi/gmp",
      },
    },
  ];

  return (
    <div className="total-page">
      <header>{isMobile ? <MobileTopBar /> : <DesktopTopBar />}</header>
      <div className="projectBody">
        <div className="body">
          <p className="topText">Take a look at some of my projects</p>
          <div className="projects">
            {PROJECT_LIST.map((project) => {
              return (
                <Project
                  key={project.name}
                  className="project"
                  labelFront={project.name}
                  labelBack={project.description}
                  labelLogo={project.logo}
                  githubLinks={project.githubLinks}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
